// The Share chip of a saved App or Artifact canvas (operator UX 2026-10-05; DES1 specs section 2): who can see it.
// Namespace `share-chip`; owner: T2-UI1. English is the source; the other 23 languages are DES2's
// (templates-save-start, connect-access and apps-0645 handoffs: the same words under one namespace).
// "Share" itself and "Try again" are the Library's artifact-panels keys.
import type { NamespaceCatalog } from '@/i18n/ns';

const en = {
  onlyYou: 'Only you',
  company: 'Company',
  shared: 'Shared',
  peopleCount: 'one:person|other:people',
};
export type ShareChipCopyKey = keyof typeof en;

export const shareChipCopy: NamespaceCatalog<ShareChipCopyKey> = {
  en,
  bg: {
    onlyYou: 'Само вие',
    company: 'Компания',
    shared: 'Споделено',
    peopleCount: 'one:човек|other:души',
  },
  cs: {
    onlyYou: 'Jen vy',
    company: 'Firma',
    shared: 'Sdílená',
    peopleCount: 'one:člověk|few:lidé|many:lidí|other:lidí',
  },
  da: {
    onlyYou: 'Kun dig',
    company: 'Virksomhed',
    shared: 'Delt',
    peopleCount: 'one:person|other:personer',
  },
  de: {
    onlyYou: 'Nur Sie',
    company: 'Unternehmen',
    shared: 'Geteilt',
    peopleCount: 'one:Person|other:Personen',
  },
  el: {
    onlyYou: 'Μόνο εσείς',
    company: 'Εταιρεία',
    shared: 'Κοινόχρηστη',
    peopleCount: 'one:άτομο|other:άτομα',
  },
  es: {
    onlyYou: 'Solo tú',
    company: 'Empresa',
    shared: 'Compartida',
    peopleCount: 'one:persona|other:personas',
  },
  et: {
    onlyYou: 'Ainult sina',
    company: 'Ettevõte',
    shared: 'Jagatud',
    peopleCount: 'one:inimene|other:inimest',
  },
  fi: {
    onlyYou: 'Vain sinä',
    company: 'Organisaatio',
    shared: 'Jaettu',
    peopleCount: 'one:henkilö|other:henkilöä',
  },
  fr: {
    onlyYou: 'Vous uniquement',
    company: 'Entreprise',
    shared: 'Partagée',
    peopleCount: 'one:personne|other:personnes',
  },
  ga: {
    onlyYou: 'Tusa amháin',
    company: 'Comhlacht',
    shared: 'Comhroinnte',
    peopleCount: 'one:duine|two:dhuine|few:dhuine|many:nduine|other:duine',
  },
  hr: {
    onlyYou: 'Samo vi',
    company: 'Tvrtka',
    shared: 'Dijeljeno',
    peopleCount: 'one:osoba|few:osobe|other:osoba',
  },
  hu: {
    onlyYou: 'Csak Ön',
    company: 'Cég',
    shared: 'Megosztott',
    peopleCount: 'one:fő|other:fő',
  },
  it: {
    onlyYou: 'Solo tu',
    company: 'Azienda',
    shared: 'Condivisa',
    peopleCount: 'one:persona|other:persone',
  },
  lt: {
    onlyYou: 'Tik jūs',
    company: 'Įmonė',
    shared: 'Bendrinama',
    peopleCount: 'one:žmogus|few:žmonės|many:žmogaus|other:žmonių',
  },
  lv: {
    onlyYou: 'Tikai jūs',
    company: 'Uzņēmums',
    shared: 'Kopīgota',
    peopleCount: 'zero:cilvēku|one:cilvēks|other:cilvēki',
  },
  mt: {
    onlyYou: 'Int biss',
    company: 'Kumpanija',
    shared: 'Maqsuma',
    peopleCount: 'one:persuna|two:persuni|few:persuni|many:persuna|other:persuna',
  },
  nl: {
    onlyYou: 'Alleen jij',
    company: 'Bedrijf',
    shared: 'Gedeeld',
    peopleCount: 'one:persoon|other:personen',
  },
  pl: {
    onlyYou: 'Tylko ty',
    company: 'Firma',
    shared: 'Udostępniona',
    peopleCount: 'one:osoba|few:osoby|many:osób|other:osoby',
  },
  pt: {
    onlyYou: 'Só para si',
    company: 'Empresa',
    shared: 'Partilhada',
    peopleCount: 'one:pessoa|other:pessoas',
  },
  ro: {
    onlyYou: 'Doar tu',
    company: 'Companie',
    shared: 'Partajată',
    peopleCount: 'one:persoană|few:persoane|other:de persoane',
  },
  sk: {
    onlyYou: 'Len vy',
    company: 'Firma',
    shared: 'Zdieľaná',
    peopleCount: 'one:človek|few:ľudia|many:ľudí|other:ľudí',
  },
  sl: {
    onlyYou: 'Samo vi',
    company: 'Podjetje',
    shared: 'V skupni rabi',
    peopleCount: 'one:oseba|two:osebi|few:osebe|other:oseb',
  },
  sv: {
    onlyYou: 'Bara du',
    company: 'Företag',
    shared: 'Delad',
    peopleCount: 'one:person|other:personer',
  },
};
export default shareChipCopy;
